import { ArrowUp } from "lucide-react";
import { DONATE_URL, CONTACT_URL, AREAS } from "./data";
import { SmartLink } from "./SmartLink";

const LINKS = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about-us" },
  { label: "Areas of Work", href: "/areas-of-work" },
  { label: "Donate", href: DONATE_URL },
  { label: "Contact", href: CONTACT_URL },
  { label: "Gallery", href: "/gallery" },
  { label: "Information Hub", href: "/information-hub" },
  { label: "Research Studies", href: "/research-studies" },
  { label: "Diversity Policy", href: "/diversity-and-equal-oppertunity-policy" },
];

export const Footer = () => (
  <footer data-testid="main-footer" className="relative bg-[#0F1D2F] text-[#FAF7F2] pt-20 pb-10 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid md:grid-cols-12 gap-10 pb-16 border-b border-white/10">
        <div className="md:col-span-5">
          <img src="/images/wings.png" alt="Wings of Fire Foundation" className="w-40" />
          <p className="font-serif italic text-3xl mt-4 text-[#F2B36B]">Ignite Awareness, Inspire Change.</p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-[#94A3B8] mb-5">Foundation</p>
          <ul className="space-y-3">
            {LINKS.map((l) => (
              <li key={l.label}>
                <SmartLink href={l.href} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`} className="text-[#E2E8F0] hover:text-[#F2B36B] transition-colors">
                  {l.label}
                </SmartLink>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-[#94A3B8] mb-5">Areas of Work</p>
          <ul className="space-y-3">
            {AREAS.map((a) => (
              <li key={a.id}>
                <SmartLink href={a.href} data-testid={`footer-area-${a.id}`} className="text-[#E2E8F0] hover:text-[#F2B36B] transition-colors">
                  {a.title}
                </SmartLink>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <p aria-hidden className="font-serif text-[18vw] leading-[0.85] tracking-tight text-white/[0.06] select-none mt-8 whitespace-nowrap">
        Wings of Fire
      </p>
      <div className="flex flex-wrap items-center justify-between gap-4 mt-6 text-sm text-[#94A3B8]">
        <p data-testid="footer-copyright">© 2026 Wings of Fire Foundation</p>
        <button onClick={() => (window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" }))} data-testid="footer-back-to-top-button" className="inline-flex items-center gap-2 hover:text-[#F2B36B] transition-colors">
          Back to top <ArrowUp className="w-4 h-4" />
        </button>
      </div>
    </div>
  </footer>
);
